import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import DashboardCard from "./DashboardCard";
import {
  FcDiploma1,
  FcDiploma2,
  FcMoneyTransfer,
  FcOrgUnit,
  FcRules,
  FcTodoList,
} from "react-icons/fc";

const DashboardCards = () => {
  const { dashboardData: data } = useSelector((state) => state.dashboardState);
  return (
    <div className="mb-3">
      <Row gutter={4}>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="PROJECTS IDENTIFIED"
            value={data.donors?.totalDonors}
            icon={<FcOrgUnit />}
          />
        </Col>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="PROJECTS SUBMITTED"
            value={data.donors?.proposalStatusPending}
            icon={<FcDiploma1 />}
          />
        </Col>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="PROJECTS APPROVED"
            value={data.projects?.approvedProjects}
            icon={<FcDiploma2 />}
          />
        </Col>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="REQUISITIONS PREPARED"
            value={Number(
              data.requisitionMemos?.totalRequisitionMemos || 0
            )?.toLocaleString()}
            icon={<FcRules />}
          />
        </Col>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="FUNDS ADVANCE FORMS PREPARED"
            value={Number(
              data.paymentVouchers?.totalPaymentVouchers || 0
            )?.toLocaleString()}
            icon={<FcMoneyTransfer />}
          />
        </Col>
        <Col md={4} sm={12} lg={4} xs={12}>
          <DashboardCard
            title="PAYMENT VOUCHERS PREPARED"
            value={Number(
              data.advanceAccountabilityForms
                ?.totalAdvanceAccountabilityForms || 0
            )?.toLocaleString()}
            icon={<FcTodoList />}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DashboardCards;
